<template>
  <div class="m-num-g1" ref="statsSection" :style="bgImage ? { backgroundImage: `url(${bgImage})` } : {}">
    <div class="wp">
      <ul class="ul-txt-g1">
        <li v-for="(stat, index) in stats" :key="index">
          <div :class="['n1', `n1${index + 1}`]">
            <span class="timer" ref="timer">{{ displayNumbers[index] }}</span>
            <em>{{ stat.unit }}</em>
            <p>{{ stat.label }}</p>
          </div>
          <p>{{ stat.subtitle }}</p>
          <div class="txt">{{ stat.description }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stats',
  data() {
    return {
      bgImage: '', // 可以添加背景图片路径
      displayNumbers: [0, 0, 0, 0], // 当前显示的数字
      animated: false, // 是否已经播放过动画
      observer: null, // IntersectionObserver 实例
      stats: [
        {
          number: 15,
          unit: '年',
          label: '历史',
          subtitle: '中小企业品牌服务商',
          description: '豪禾服务中国中小企业，助力品牌成长和业绩提升，400多家客户见证豪禾与您共成长'
        },
        {
          number: 30,
          unit: '名',
          label: '员工',
          subtitle: '八位高级顾问',
          description: '豪禾特聘八位企业市场总监和品牌创始人，成立豪禾智慧库。为中小企业提供各方面品牌咨询服务。'
        },
        {
          number: 369,
          unit: '位',
          label: '客户',
          subtitle: '一站式服务',
          description: '豪禾提供从品牌设计到营销执行的专业产业链一站式服务。深入洞察企业，贴身服务，快速反应。'
        },
        {
          number: 50,
          unit: '+',
          label: '品牌全案',
          subtitle: '低成本运作',
          description: '豪禾深刻体会中小企业发展瓶颈和难处，以低成本运作为原则，定位营销，快速实现业绩倍增。'
        }
      ]
    }
  },
  mounted() {
    this.setupIntersectionObserver()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    setupIntersectionObserver() {
      // 使用 Intersection Observer API 检测元素是否进入视口
      if (typeof IntersectionObserver !== 'undefined') {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // 当元素进入视口且动画未播放时，触发动画
              if (entry.isIntersecting && !this.animated) {
                this.animated = true
                this.animateNumbers()
                // 动画触发后，断开观察器
                this.observer.disconnect()
              }
            })
          },
          {
            // 当元素顶部距离视口底部还有 200px 时就开始触发
            rootMargin: '0px 0px -200px 0px',
            threshold: 0.1
          }
        )
        
        // 等待 DOM 更新后开始观察
        this.$nextTick(() => {
          if (this.$refs.statsSection) {
            this.observer.observe(this.$refs.statsSection)
          }
        })
      } else {
        // 降级方案：使用滚动事件（兼容不支持 IntersectionObserver 的浏览器）
        window.addEventListener('scroll', this.handleScroll)
        this.checkScroll()
      }
    },
    handleScroll() {
      if (!this.animated) {
        this.checkScroll()
      }
    },
    checkScroll() {
      if (this.$refs.statsSection) {
        const element = this.$refs.statsSection
        const elementTop = element.offsetTop
        const windowHeight = window.innerHeight
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        
        // 当滚动到距离元素顶部700px以内时触发动画
        if (scrollTop + windowHeight >= elementTop - 700 && !this.animated) {
          this.animated = true
          this.animateNumbers()
          window.removeEventListener('scroll', this.handleScroll)
        }
      }
    },
    animateNumbers() {
      this.stats.forEach((stat, index) => {
        const targetNumber = stat.number
        const duration = 2500 // 动画持续时间（毫秒）
        const steps = 60 // 动画步数
        const increment = targetNumber / steps
        let currentStep = 0
        
        const timer = setInterval(() => {
          currentStep++
          if (currentStep <= steps) {
            const currentNumber = Math.floor(increment * currentStep)
            this.$set(this.displayNumbers, index, currentNumber > targetNumber ? targetNumber : currentNumber)
          } else {
            this.$set(this.displayNumbers, index, targetNumber)
            clearInterval(timer)
          }
        }, duration / steps)
      })
    }
  }
}
</script>

<style scoped>
.m-num-g1 {
  padding: 110px 0 70px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  overflow: hidden;
}

.wp {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.ul-txt-g1 {
  margin: 0 -32px;
  padding: 0;
  list-style: none;
  overflow: hidden;
}

.ul-txt-g1 li {
  width: 25%;
  float: left;
  text-align: center;
  position: relative;
  padding: 0 32px;
  box-sizing: border-box;
}

.ul-txt-g1 li:first-child:before {
  display: none;
}

.ul-txt-g1 .n1 {
  width: 200px;
  height: 200px;
  margin: 0 auto 15px;
  font-size: 0;
  border: 1px solid #ccc;
  border-radius: 50%;
  position: relative;
  padding-top: 53px;
}

.ul-txt-g1 .n11 {
  border-color: #00913a;
  color: #00913a;
}

.ul-txt-g1 .n11 p {
  color: #00913a;
}

.ul-txt-g1 .n12 {
  border-color: #00a0e9;
  color: #00a0e9;
}

.ul-txt-g1 .n12 p {
  color: #00a0e9;
}

.ul-txt-g1 .n13 {
  border-color: #f39800;
  color: #f39800;
}

.ul-txt-g1 .n13 p {
  color: #f39800;
}

.ul-txt-g1 .n14 {
  border-color: #d70051;
  color: #d70051;
}

.ul-txt-g1 .n14 p {
  color: #d70051;
}

.ul-txt-g1 .n1 em,
.ul-txt-g1 .n1 span {
  display: inline-block;
  font-size: 65px;
  line-height: 1.2;
}

.ul-txt-g1 .n1 em {
  font-size: 24px;
  vertical-align: baseline;
  margin-left: 5px;
}

.ul-txt-g1 p {
  font-size: 18px;
  color: #242526;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  text-align: center;
  margin: 10px 0;
}

.ul-txt-g1 .n1 p {
  font-size: 22px;
  text-align: center;
  margin: 0;
}

.ul-txt-g1 .txt {
  padding: 0 50px;
  width: 100%;
  line-height: 1.8em;
  height: 7em;
  margin-top: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  font-size: 14px;
  color: #666;
  box-sizing: border-box;
}

@media (max-width: 1200px) {
  .m-num-g1 {
    padding: 40px 0 50px;
  }

  .wp {
    padding: 0;
  }

  .ul-txt-g1 {
    margin: 0;
  }

  .ul-txt-g1 li {
    padding: 0;
    width: 25%;
  }

  .ul-txt-g1 .n1 span {
    font-size: 54px;
  }

  .ul-txt-g1 .n1 em {
    font-size: 20px;
  }

  .ul-txt-g1 p {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .ul-txt-g1 li {
    width: 50%;
    margin-bottom: 30px;
  }

  .ul-txt-g1 li:before {
    height: 70px;
    margin-top: -35px;
  }

  .ul-txt-g1 .n1 span {
    font-size: 40px;
  }

  .ul-txt-g1 .n1 em {
    font-size: 18px;
  }

  .ul-txt-g1 .n1 p {
    font-size: 20px;
  }

  .ul-txt-g1 .txt {
    padding: 0 20px;
    height: auto;
    margin-top: 10px;
  }
}

@media (max-width: 480px) {
  .m-num-g1 {
    padding: 30px 0 40px;
  }

  .ul-txt-g1 .n1 {
    width: 150px;
    height: 150px;
    padding-top: 40px;
  }

  .ul-txt-g1 .n1 span {
    font-size: 36px;
  }

  .ul-txt-g1 .n1 em {
    font-size: 14px;
  }

  .ul-txt-g1 .n1 p {
    font-size: 16px;
  }

  .ul-txt-g1 .txt {
    padding: 0 5px;
  }
}
</style>
